<template>
  <ScrollArea
    ref="root"
    :class="['flex', direction === 'vertical' ? 'flex-col touch-pan-y' : 'flex-row touch-pan-x']"
    :direction="direction"
    :dir="dir"
  >
    <slot />
  </ScrollArea>
</template>
<script lang="ts" setup>
import { useScroll } from '@vueuse/core'
import { PropType } from 'vue'
type ScrollAreaDir = 'horizontal' | 'vertical'
interface ScrollAreaOffset {
  left?: number
  top?: number
  bottom?: number
  right?: number
}
const props = defineProps({
  direction: {
    type: String as PropType<ScrollAreaDir>,
    default: 'vertical'
  },
  reset: Boolean,
  offset: {
    type: Object as PropType<ScrollAreaOffset>,
    default: () => {}
  },
  initialY: {
    type: Number,
    default: 0
  },
  initialX: {
    type: Number,
    default: 0
  },
  dir: {
    type: String as PropType<'ltr' | 'rtl'>,
    default: 'ltr'
  }
})
const emit = defineEmits(['scrollEnd', 'update:reset'])
const root = ref<any>(null)
const viewportElem = ref<HTMLElement | null>(null)
const { x, y, arrivedState } = useScroll(viewportElem, {
  offset: props.offset
})
const { bottom, right } = toRefs(arrivedState)

function resetScrollArea() {
  x.value = 0
  y.value = 0
  emit('update:reset', false)
}
function setScrollArea(initialX: number, initialY: number) {
  x.value = initialX
  y.value = initialY
}
watch(
  () => [bottom.value, right.value],
  ([bottomVal, rightVal]) => {
    if ((bottomVal && props.direction === 'vertical') || (rightVal && props.direction === 'horizontal')) {
      emit('scrollEnd')
    }
  }
)

watch(
  () => props.reset,
  (value) => {
    if (value) {
      resetScrollArea()
    }
  }
)
watch(
  () => [props.initialX, props.initialY],
  ([x, y]) => {
    setScrollArea(x, y)
  }
)
onMounted(() => {
  viewportElem.value = root.value.$el.firstElementChild
})
</script>
